import { BuildType } from 'src/enums/build/build-type';
import FixedImage from 'src/components/common/fixed-image';
import fixedImages from 'src/helpers/fixed-images';
import DavidLloydLogo from 'src/components/icons/david-lloyd-logo';
import React, { useContext } from 'react';
import { SiteContext } from 'src/context/site-context';

type HeaderLogoProps = {
  davidLloydSize: string;
  meridianSize: string;
};

const HeaderLogo = ({ davidLloydSize, meridianSize }: HeaderLogoProps) => {
  const { buildType } = useContext(SiteContext);

  if (buildType === BuildType.MERIDIAN) {
    return (
      <div
        css={{
          width: meridianSize,
          margin: '-0.5rem',
          img: { objectFit: 'contain' },
        }}
      >
        <FixedImage imageDetails={fixedImages.darkBgMeridianLogo} />
      </div>
    );
  }

  return <DavidLloydLogo size={davidLloydSize} />;
};

export { HeaderLogo };
